import { render, staticRenderFns } from "./SelectorByCode.vue?vue&type=template&id=966ca6a2&"
import script from "./SelectorByCode.vue?vue&type=script&lang=js&"
export * from "./SelectorByCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports